const {
    WesternSahara,
    UnitedStates,
    DRCongo,
    DominicanRepublic,
    FalklandIslands,
    FrenchSouthernandAntarcticLands,
    IvoryCoast,
    CentralAfricanRepublic,
    RepublicoftheCongo,
    EquatorialGuinea,
    SolomonIslands,
    Cyprus,
    BosniaandHerzegovina,
    SouthSudan,
} = DjangIO.app.person.types.Country

export const worldRegionsMapper = new Map([
    ["W. Sahara", WesternSahara.label],
    ["United States of America", UnitedStates.label],
    ["Dem. Rep. Congo", DRCongo.label],
    ["Dominican Rep.", DominicanRepublic.label],
    ["Falkland Is.", FalklandIslands.label],
    ["Fr. S. Antarctic Lands", FrenchSouthernandAntarcticLands.label],
    ["Côte d'Ivoire", IvoryCoast.label],
    ["Central African Rep.", CentralAfricanRepublic.label],
    ["Congo", RepublicoftheCongo.label],
    ["Eq. Guinea", EquatorialGuinea.label],
    // ["eSwatini", ]
    ["Solomon Is.", SolomonIslands.label],
    ["N. Cyprus", Cyprus.label],
    // ["Somaliland"]
    ["Bosnia and Herz.", BosniaandHerzegovina.label],
    ["S. Sudan", SouthSudan.label],
])
